import React, { useEffect, useState } from 'react';
import { Components } from './styled';
import { Profile } from '../../api/types/profile';
import { Author } from '../../api/types/author';
import { PUBLIC_BUCKET } from '../../defines';

const ProfileAvatar = ({
  author,
  profile,
  onClick,
  size,
  initials,
  imageUrl,
}: {
  author?: Author;
  profile?: Profile;
  onClick?: (event: any) => void;
  size: 24 | 32 | 42 | 56 | 64 | 96;
  initials?: string;
  imageUrl?: string;
}) => {
  const _initials = author ? author?.initials : (profile ? profile?.initials : undefined) || initials || '';
  const _imageUrl = author && author?.imagePath ? PUBLIC_BUCKET + author?.imagePath : imageUrl;

  const [hasImageError, setHasImageError] = useState(false);

  // Retry when the URL changes, e.g. after a new image is uploaded.
  useEffect(() => {
    setHasImageError(false);
  }, [_imageUrl]);

  const _onClick = (event: any) => {
    onClick?.(event);
  };

  return (
    <Components.Container onClick={_onClick} canBeClicked={!!onClick}>
      {_imageUrl && _imageUrl?.length > 0 && !hasImageError ? (
        <Components.UserImage src={_imageUrl} dimension={size} onError={() => setHasImageError(true)} />
      ) : (
        <Components.UserBgIcon dimension={size}>
          <Components.UserInitials size={size}>{_initials}</Components.UserInitials>
        </Components.UserBgIcon>
      )}
    </Components.Container>
  );
};

export default ProfileAvatar;
